import React from 'react'
import { useQuery } from 'react-query'
import Project from './Project'

const JsProjects = () => {
    const { data, isLoading } = useQuery('projects', () => fetch('./services.json').then(res => res.json()))

    if (isLoading) {
        return <button class="btn loading">loading</button>
    }

    return (
        <div className="grid lg:grid-cols-3 gap-8 mt-6">
            {data.slice(8, 13).map(service => (
                <Project key={service.id} service={service} />
            ))}
        </div>
    )
}

export default JsProjects
